import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { PencilIcon } from '../../../../../../common/icons';

import './UpdateGroupModal.css';
import AirButton from '../../../../../../common/components/AirButton';
import AirModal from '../../../../../../common/components/AirModal';
import AirInput from '../../../../../../common/components/AirInput';

@inject('translationsStore', 'groupsStore', 'commonStore')
@observer
export default class UpdateGroupModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      group: {}
    };
  }

  componentDidUpdate = prevState => {
    if (!!this.props.group) {
      if (this.props.group.id !== (prevState.group || {}).id) {
        this.setState({ group: this.props.group });
      }
      if (this.props.group.id === (prevState.group || {}).id && this.props.group.updatedAt !== prevState.group.updatedAt) {
        this.setState({ group: this.props.group });
      }
    }
  };

  show = () => {
    this.setState({ visible: true });
  };

  close = () => {
    this.setState({ visible: false });
  };

  setName = e => {
    this.setState({ group: Object.assign({}, this.state.group, { name: e.target.value }) });
  };

  setDescription = e => {
    this.setState({ group: Object.assign({}, this.state.group, { description: e.target.value }) });
  };

  setPhoneNumber = e => {
    this.setState({ group: Object.assign({}, this.state.group, { phoneNumber: e.target.value }) });
  };

  updateGroup = () => {
    const { group } = this.state;
    const { commonStore, groupsStore } = this.props;
    if (!!group) {
      this.close();
      commonStore.setLoadingMessage('aggiornamento gruppo...');
      commonStore.setLoading(true);
      groupsStore.update(group.id, group.name, group.description, group.phoneNumber).then(() => {
        commonStore.setLoading(false);
      });
    } else {
      console.log('error');
    }
  };

  deleteGroup = () => {
    const { group } = this.state;
    const { commonStore, groupsStore } = this.props;
    if (!!group) {
      this.close();
      commonStore.setLoadingMessage('cancellazione gruppo...');
      commonStore.setLoading(true);
      groupsStore.delete(group.id).then(() => {
        commonStore.setLoading(false);
      });
    } else {
      console.log('error');
    }
  };

  render() {
    const { translationsStore } = this.props;
    const { group } = this.state;
    return (
      <AirModal
        className="UpdateGroupModal"
        visible={this.state.visible}
        icon={<PencilIcon style={{ width: '42px', height: '39px' }} />}
        onCancel={this.close}
        okButton={<AirButton size="large" light label={translationsStore.translate('updategroup.update')} />}
        onOk={this.updateGroup}
        cancelButton={<AirButton className="nobg" size="large" light label={translationsStore.translate('updategroup.delete')} />}
        onClickCancel={this.deleteGroup}
        title={translationsStore.translate('updategroup.modaltitle')}
      >
        <div>
          <AirInput label={translationsStore.translate('newgroup.name')} value={group.name} onChange={this.setName} maxlength="20" />
          <AirInput
            label={translationsStore.translate('newgroup.description')}
            textarea
            value={group.description}
            onChange={this.setDescription}
            maxlength="100"
            autosize={{ minRows: 2, maxRows: 2 }}
          />
          <AirInput
            label={translationsStore.translate('newgroup.phoneNumber')}
            value={group.phoneNumber}
            onChange={this.setPhoneNumber}
            maxlength="20"
          />
        </div>
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/GroupDetail/UpdateGroupModal/UpdateGroupModal.js